import { useState } from "react";
import { Col, Tabs, Tab } from "react-bootstrap";

import classes from "./profile.module.scss";
import ProfileTabForm from "./ProfileTabForm";
import ProfileTabSecurity from "./ProfileTabSecurity";

const ProfileTab = ({ data, setData }) => {
	const [selected, setSelected] = useState("general");

	return (
		<Col>
			<Tabs activeKey={selected} id="profile_tabs" onSelect={(k) => setSelected(k)}>
				<Tab eventKey="general" title="General" className={classes.tab_content}>
					<ProfileTabForm data={data} setData={setData} />
				</Tab>
				<Tab eventKey="seguridad" title="Seguridad" className={classes.tab_content}>
					<ProfileTabSecurity data={data} setData={setData} />
				</Tab>
			</Tabs>
		</Col>
	);
};

export default ProfileTab;
